import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { getServerJoinUrl } from "../../utilities";

import "./JoinQRCodeButton.css";

const FEEDBACK_TIMEOUT = 700;

/**
 * Get a CSS variable's computed value as a color string.
 * Falls back to provided default if variable is not set.
 */
function getThemeColor(varName, fallback) {
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
    return value || fallback;
}

/**
 * JoinQRCodeButton - A clickable QR code that copies the join URL to clipboard.
 *
 * Props:
 * - roomCode: The room code to generate the join URL
 * - size: QR code size in pixels (default: 56)
 */
function JoinQRCodeButton({ roomCode, size = 56 }) {
    const [copyState, setCopyState] = useState("idle"); // "idle" | "success" | "error"

    const joinUrl = getServerJoinUrl(roomCode);

    const handleClick = async () => {
        try {
            await navigator.clipboard.writeText(joinUrl);
            setCopyState("success");
        } catch {
            setCopyState("error");
        }
        setTimeout(() => setCopyState("idle"), FEEDBACK_TIMEOUT);
    };

    const stateClass = copyState !== "idle" ? `join-qr-button--${copyState}` : "";

    return (
        <button
            className={`join-qr-button ${stateClass}`}
            onClick={handleClick}
            title={`Click to copy: ${joinUrl}`}
            type="button"
        >
            <QRCodeCanvas
                value={joinUrl}
                size={size}
                includeMargin={false}
                bgColor={getThemeColor("--surface", "#ffffff")}
                fgColor={getThemeColor("--text", "#000000")}
            />
            {copyState === "success" && (
                <div className="join-qr-button__feedback">Copied!</div>
            )}
        </button>
    );
}

export default JoinQRCodeButton;
